import styled from '@emotion/styled';
import React from 'react';

interface SidebarHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const StyledSidebarHeader = styled.div`
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  padding: 0 20px;

  > div {
    width: 100%;
    overflow: hidden;
  }
`;

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ children, ...rest }) => {
  return (
    <StyledSidebarHeader {...rest}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <a href="/">
          <img
            src={require('../../../assets/images/logo-v2.png')}
            alt=""
            style={{ height: 30 }}
          />
        </a>
      </div>
    </StyledSidebarHeader>
  );
};

export default SidebarHeader;
